import { Toast } from "@tandemdiabetes/sugarmate-react-components"
import { usePolyglot } from "src/contexts"

interface Props {
  id: string;
}

export function DuplicateSubEntrySuccessToast(props: Props) {
  const polyglot = usePolyglot()

  return (
    <Toast
      stylePreset="success"
      body={polyglot.t("toasts.duplicate_sub_entry_success.body")}
      id={props.id}
    />
  )
}
